var CustomerModule = (function () {
    function CustomerModule() {
    }
    return CustomerModule;
}());
export { CustomerModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer.module.ts.pre-build-optimizer.js